export default __webpack_public_path__ + "static/media/icon_wechat_cirle.36d80121.svg";